module.exports = __webpack_public_path__ + "img/backgroundMenu.75ff7f27.jpg";